import { COLORS, STATUS } from '@btime/constants'
import { compose, head, path, propOr } from 'ramda'
import { useFilter, useFilterActions } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useStatusOptionFormatter } from '../../../utils/helpers/status'
import TabsMenu, { Tab } from '../../../components/tabs/TabsMenu'

const { OPEN, PENDING, COMPLETED } = STATUS

const ALL = 'all'
const fastFilterStatuses = [OPEN, PENDING, COMPLETED]

const FastFilters = () => {
  const { t } = useTranslation()
  const formatStatus = useStatusOptionFormatter()
  const filter = useFilter()
  const { setFilterAndTempFilterValue, clear } = useFilterActions()
  const selectedStatuseIds = propOr([], 'statusIds', filter)
  let selectedStatus = compose(path(['origin', 'name']), head)(selectedStatuseIds)

  if (selectedStatuseIds.length > 1 || (!!selectedStatus && !fastFilterStatuses.includes(selectedStatus))) return false

  return (
    <TabsMenu>
      <Tab
        useButtonStyle
        color={!selectedStatus ? COLORS.purple : COLORS.dark3}
        active={!selectedStatus}
        onClick={() => setFilterAndTempFilterValue('statusIds', [])}
      >
        {t('status.all', { count: 2 })}
      </Tab>

      {fastFilterStatuses.map(statusName => {
        const active = statusName === selectedStatus
        const option = formatStatus(statusName)
        return (
          <Tab
            key={statusName}
            useButtonStyle
            color={active ? COLORS.purple : COLORS.dark3}
            active={active}
            onClick={() => setFilterAndTempFilterValue('statusIds', [option])}
          >
            {option.label}
          </Tab>
        )
      })}
    </TabsMenu>
  )
}

export default FastFilters
